import { useContext } from "react";
import { Grid, Typography } from "@material-ui/core";
import { DataGrid } from "../../../../../../shared/components";
import { AltaContext } from "../../../../context";
import { useResultColumns } from "../hooks";
import { FailedTableInfo } from "./failedTableInfo";

export const ResultTable = () => {
  const columns = useResultColumns();
  const { savedPersons, diferencia, badPersons } = useContext(AltaContext);
  return (
    <>
      {!!badPersons.length && <FailedTableInfo rows={badPersons} />}
      <Typography variant="h6" color="primary">
        {" "}
        Situaciones Guardadas{" "}
      </Typography>
      <DataGrid columns={columns} rows={savedPersons} id="titular" />
      <Grid container spacing={2}>
        <Grid item>
          <Typography>Importe Actual: {diferencia.importeActual}</Typography>
        </Grid>
        <Grid item>
          <Typography>Importe Anterior: {diferencia.importeAnterior}</Typography>
        </Grid>
        <Grid item>
          <Typography>Diferencia: {diferencia.importeDiferencia}</Typography>
        </Grid>
      </Grid>
    </>
  );
};
